import Gtm from "./GTM";

class MobileMenu {
    gtm: Gtm;
    menuOpenClass: string;
    menu: Element;
    menuTrigger: string;
    menuTriggerNodes: NodeListOf<Element>;

    menuClosedAriaLabel = "Öppna navigationsmenyn";
    menuOpenAriaLabel = "Stäng navigationsmenyn";

    constructor() {
        this.gtm = new Gtm();
        this.menuOpenClass = "mobile-menu-open";
        this.menu = document.getElementsByClassName(
            "site-header__menu-mobile",
        )[0];
        this.menuTrigger = "[data-toggle-menu]";

        this.menuTriggerNodes = document.querySelectorAll(this.menuTrigger);
        this.addEvents(this.menuTriggerNodes);
    }

    /**
     * Add a toggleMenu event to each NodeList element provided.
     * @param triggerName
     */
    addEvents(triggerNodes: NodeListOf<Element>) {
        [...Array.from(triggerNodes)].forEach((el) => {
            el.addEventListener("click", () => {
                this.toggleMenu();
            });
        });
    }
    toggleMenu() {
        requestAnimationFrame(() => {
            document.body.classList.toggle(this.menuOpenClass);
            if (document.body.classList.contains(this.menuOpenClass)) {
                this.menuTriggerNodes[0].setAttribute(
                    "aria-label",
                    this.menuOpenAriaLabel,
                );
                this.gtm.datalayerPush("dropdown_menu_open");
            } else {
                this.menuTriggerNodes[0].setAttribute(
                    "aria-label",
                    this.menuClosedAriaLabel,
                );
                this.gtm.datalayerPush("dropdown_menu_close");
            }
        });
    }
}

export default MobileMenu;
